import React, { useEffect, useState, useCallback } from 'react';
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Badge,
  Select,
  Space,
  Switch,
  Tooltip,
  Tree,
  Modal,
  Avatar,
  Upload,
  Pagination,
  Table
} from 'antd';
import { usePageData } from '../../../hooks/usePage';
import { IPageData } from '../../../interfaces/page';
import { EditOutlined, DeleteOutlined, UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import generalesProvider from '../../../services/generalesProvider';
import { Divider } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import { useLocation, useHistory } from 'react-router-dom';
import './regdocumentos.css';
import gestionDocumentosProvider from '../../../services/gestiondocumentos';
import { saveAs } from 'file-saver';
const moment = require('moment');
const { Option } = Select;
const { Search } = Input;

const pageData: IPageData = {
  fulFilled: true,
  breadcrumbs: [
    {
      title: 'Administración de Documentos',
      route: 'administracion-documentos'
    },
    {
      title: 'Registro de Documentos'
    }
  ]
};
const key = 'regitrando';
const EditDocumentos = () => {
  const location: any = useLocation();
  let history = useHistory();
  usePageData(pageData);
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 8
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 16
      }
    }
  };
  const [data, setData] = useState({ data: [], totalRecords: 0 });
  const [current, setCurrent] = useState(1);
  const [formFile] = Form.useForm();
  const [isModalHistorialDocumentosVisible, setisModalHistorialDocumentosVisible] = useState(false);
  const [isDisabled, setisDisabled] = useState(false);
  const [adjuntos, setadjuntos] = useState([]);
  const [listCategoria, setListCategoria] = useState<any>([]);
  const [listAprobadores, setListAprobadores] = useState<any>([]);
  const [estadoDocumento, setEstadoDocumento] = useState('');
  //#region metodo de tree
  const pageSize = 5;
  const PaginacionPersonalizada = ({ total, onChange, current }) => {
    return (
      <Pagination
        onChange={onChange}
        simple={true}
        total={total}
        current={current}
        pageSize={pageSize}
      />
    );
  };
  const columns = [
    {
      title: 'Nombre Documento',
      dataIndex: 'nombredocumento',
      key: 'nombredocumento',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Versión Documento',
      dataIndex: 'versiondocumento',
      key: 'versiondocumento',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Proceso',
      dataIndex: 'proceso',
      key: 'proceso',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Dirección',
      dataIndex: 'direccion',
      key: 'direccion',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Area',
      dataIndex: 'area',
      key: 'area',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },

    {
      title: 'Responsable',
      dataIndex: 'responsable',
      key: 'responsable',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Ubicación',
      dataIndex: 'ubicacion',
      key: 'ubicacion',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Estado',
      dataIndex: 'descripcionEstado',
      key: 'descripcionEstado',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Acción',
      key: 'action',
      render: (text, record) => {
        return (
          <Space size='middle'>
            <Button
              size='small'
              type='primary'
              onClick={(e) => btnDescargarHistorialDocumento(text.id)}
            >
              Descargar Adjuntos
            </Button>
          </Space>
        );
      },
      align: 'center' as 'center'
    }
  ];
  const listarArchivos = async (id) => {
    const paginacion = {
      pagenum: current,
      pagesize: pageSize,
      id: id
    };
    const res: any = await gestionDocumentosProvider.ListarHistorialArchivoPaginado(paginacion);
    if (res.data) setData(res);
  };
  useEffect(() => {
    if (location.state) listarArchivos(location.state.id);
    else history.push('/vertical/administracion-documentos');
  }, [current]);

  const btnDescargarHistorialDocumento = async (id) => {
    const responsemodelo: any = await gestionDocumentosProvider.obtenerAdjuntoModel({ id: id });
    const response = await gestionDocumentosProvider.obtenerAdjunto(id);
    saveAs(response, responsemodelo.nombrearchivo);
    // const response = await gestionDocumentosProvider.obtenerAdjunto(id);
    // saveAs(response, "descargas");
  };
  useEffect(() => {
    if (location.state) {
      (async () => {
        await ObtenerArchivosPorId(location.state.id);
        // if (location.state.idestado == 2)
        //     setisDisabled(true);
      })();
    } else {
      history.push('/vertical/administracion-documentos');
    }
  }, []);
  const ObtenerArchivosPorId = async (id) => {
    const res = await gestionDocumentosProvider.ObtenerArchivosPorId({ id: id });
    const archivo = res.data[0];
    setEstadoDocumento(archivo.descripcionEstado);
    formFile.setFieldsValue({
      id: archivo.id,
      nombredocumento: archivo.nombredocumento,
      codigodocumento: archivo.codigodocumento,
      versiondocumento: archivo.versiondocumento,
      idcategoria: archivo.idcategoria,
      proceso: archivo.proceso,
      direccion: archivo.direccion,
      area: archivo.area,
      responsable: archivo.responsable,
      ubicacion: archivo.ubicacion
    }); //seteamos el
    if (archivo.idaprobador !== 0) {
      formFile.setFieldsValue({ idaprobador: archivo.idaprobador }); //seteamos el
    }
  };
  const obtenerListaValor = async () => {
    const resAprobadores: any = await gestionDocumentosProvider.ObtenerAprobadores();
    if (resAprobadores.succeeded) setListAprobadores(resAprobadores.data);
    //const categorias = await generalesProvider.obtenerListaValor(10);
    const categorias = await generalesProvider.ObtenerListaValorPorSkeyCab({
      skeycab: 'SKEYCATEGORIAGESTIONDOCUMENTO'
    });
    setListCategoria(categorias);
  };

  useEffect(() => {
    obtenerListaValor();
  }, []);
  //#endregion
  //#region metodo de crear directorio

  const IsModalHistorialDocumentoCancel = () => {
    setisModalHistorialDocumentosVisible(false);
  };
  //#endregion

  //#region metodo de crear file
  const onSubmitCrearFileOk = useCallback(async (values, adjuntos) => {
    /*Insertamos nodo en el tree */
    const request = new FormData();
    request.append(
      'codigodocumento',
      values.getFieldValue('codigodocumento') === undefined
        ? ''
        : values.getFieldValue('codigodocumento')
    );
    request.append(
      'id',
      values.getFieldValue('id') === undefined ? '0' : values.getFieldValue('id')
    );
    request.append(
      'padre',
      values.getFieldValue('padre') === undefined ? '0' : values.getFieldValue('padre')
    );
    request.append(
      'idaprobador',
      values.getFieldValue('idaprobador') === undefined ? '0' : values.getFieldValue('idaprobador')
    );
    request.append(
      'idcategoria',
      values.getFieldValue('idcategoria') === undefined ? '0' : values.getFieldValue('idcategoria')
    );
    request.append('nombredocumento', values.getFieldValue('nombredocumento'));
    request.append('versiondocumento', values.getFieldValue('versiondocumento'));
    request.append(
      'proceso',
      values.getFieldValue('proceso') === undefined ? '' : values.getFieldValue('proceso')
    );
    request.append(
      'direccion',
      values.getFieldValue('direccion') === undefined ? '' : values.getFieldValue('direccion')
    );
    request.append(
      'area',
      values.getFieldValue('area') === undefined ? '' : values.getFieldValue('area')
    );
    request.append(
      'responsable',
      values.getFieldValue('responsable') === undefined ? '' : values.getFieldValue('responsable')
    );
    request.append(
      'ubicacion',
      values.getFieldValue('ubicacion') === undefined ? '' : values.getFieldValue('ubicacion')
    );
    adjuntos.forEach((file) => {
      request.append('FormFiles', file);
    });
    const res: any = await gestionDocumentosProvider.Registrar_Actualizar_Archivo(request);
    if (res.succeeded) {
      message.success(res.message);
      /*Reseteamos el formulario  */
      removeAdjunto(null);
      formFile.resetFields();

      await ObtenerArchivosPorId(parseInt(res.entidad));
    } else {
      message.error('Ocurreo un error al intentar crear el archivo');
    }
  }, []);
  const onCancelaCrearFile = useCallback(() => {
    formFile.resetFields();
    history.push('/vertical/administracion-documentos');
    // setShowContainerFile(false);
  }, [formFile]);

  const onVerHistorial = useCallback(
    (id) => {
      // formFile.resetFields();
      listarArchivos(id);
      // history.push('/vertical/administracion-documentos');
      setisModalHistorialDocumentosVisible(true);
    },
    [formFile]
  );
  //#endregion
  //#region metodo fileunput
  const removeAdjunto = (file) => {
    const index = adjuntos.indexOf(file);
    const newFileList = adjuntos.slice();
    newFileList.splice(index, 1);
    setadjuntos([...newFileList]);
    // setAdjunto({});
  };
  const beforeAdjunto = (file, files) => {
    setadjuntos(files);
    return false;
  };
  //#endregion
  return (
    <>
      <Card title={'Editar Documentos'}>
        <div className='row'>
          <div className='col-md-6'>
            <Form
              {...formItemLayout}
              name='register'
              initialValues={{ remember: true }}
              form={formFile}
              onFinish={() => onSubmitCrearFileOk(formFile, adjuntos)}
              scrollToFirstError
            >
              <Form.Item
                name='nombredocumento'
                label='Nombre del doc.'
                rules={[{ required: true, message: 'Nombre documento es requerido!' }]}
              >
                <Input disabled={isDisabled} />
              </Form.Item>
              <Form.Item
                name='codigodocumento'
                label='Codigo del doc.'
                // rules={[{ required: true, message: 'Codigo documento es requerido!' }]}
              >
                <Input disabled={isDisabled} />
              </Form.Item>
              <Form.Item
                name='versiondocumento'
                label='Version del doc.'
                rules={[{ required: true, message: 'Version documento es requerido!' }]}
              >
                <Input disabled={isDisabled} />
              </Form.Item>

              <Form.Item
                name='proceso'
                label='Proceso.'
                // rules={[{ required: true, message: 'proceso es requerido!' }]}
              >
                <Input disabled={isDisabled} />
              </Form.Item>

              <Form.Item
                name='direccion'
                label='Direccion.'
                // rules={[{ required: true, message: 'direccion es requerido!' }]}
              >
                <Input disabled={isDisabled} />
              </Form.Item>

              <Form.Item
                name='area'
                label='Area.'
                // rules={[{ required: true, message: 'area es requerido!' }]}
              >
                <Input disabled={isDisabled} />
              </Form.Item>

              <Form.Item
                name='responsable'
                label='Responsable.'
                // rules={[{ required: true, message: 'responsable es requerido!' }]}
              >
                <Input disabled={isDisabled} />
              </Form.Item>

              <Form.Item
                name='ubicacion'
                label='Ubicación.'
                // rules={[{ required: true, message: 'ubicación es requerido!' }]}
              >
                <Input disabled={isDisabled} />
              </Form.Item>
              <Form.Item
                name='idcategoria'
                label='Categoria'
                // rules={[{ required: true, message: 'Seleccione un Categoria!' }]}
              >
                <Select disabled={isDisabled}>
                  {listCategoria.map((p, index) => {
                    return (
                      <Option key={index} value={p.idvalor}>
                        {p.descripcionvalor}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item name='idaprobador' label='Solicitar aprob. de'>
                <Select disabled={isDisabled}>
                  {listAprobadores.map((p, index) => {
                    return (
                      <Option key={index} value={p.usuarioId}>
                        {p.nombreCompleto}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item label='key' name='key' noStyle>
                <Input type='hidden' />
              </Form.Item>
              <Form.Item label='padre' name='padre' noStyle>
                <Input type='hidden' />
              </Form.Item>
              <Form.Item label='id' name='id' noStyle>
                <Input type='hidden' />
              </Form.Item>
            </Form>
          </div>
          <div className='col-md-6'>
            <div className='row' style={{ display: estadoDocumento !== '' ? 'flex' : 'none' }}>
              <div className='col-md-12'>
                <label className='estadoDocumento'>{estadoDocumento}</label>
              </div>
            </div>
            <br />
            <div className='row'>
              <div className='col-md-12'>
                <Form.Item>
                  <Upload
                    disabled={isDisabled}
                    multiple
                    fileList={adjuntos}
                    listType='text'
                    onRemove={removeAdjunto}
                    beforeUpload={beforeAdjunto}
                    className='upload-list-inline'
                  >
                    <Button type={'link'} icon={<UploadOutlined />}>
                      Subir archivo
                    </Button>
                  </Upload>
                </Form.Item>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <Row justify={'start'}>
                  <Col>
                    <Form.Item>
                      <Space>
                        <Button
                          type='primary'
                          block
                          onClick={formFile.submit}
                          disabled={isDisabled}
                        >
                          Guardar
                        </Button>
                        <Button type='primary' onClick={() => onVerHistorial(location.state.id)}>
                          Ver Historial
                        </Button>
                        <Button type='default' onClick={onCancelaCrearFile}>
                          Cancelar
                        </Button>
                      </Space>
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Card>
      <Modal
        title='Historial de Documentos'
        visible={isModalHistorialDocumentosVisible}
        width={1000}
        closable={false}
        footer={[
          <Button key='submit' type='default' onClick={IsModalHistorialDocumentoCancel}>
            Cancelar
          </Button>
        ]}
      >
        <div className='row'>
          <div className='col-md-12'>
            <Table
              locale={{ emptyText: 'No existen registros' }}
              pagination={false}
              columns={columns}
              dataSource={data.data}
              bordered
            />
            <Row justify={'center'}>
              <Col>
                <PaginacionPersonalizada
                  total={data.totalRecords}
                  current={current}
                  onChange={setCurrent}
                />
              </Col>
            </Row>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default EditDocumentos;
